import { AbstractPmsApiService } from "./abstract.service";
import { RatePlanInterval } from "../models";
import moment from 'moment';

/**
 * @class RatePlanIntervalPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<RatePlanInterval>}
 */
export class RatePlanIntervalPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/property/:propertyId/rate-plan/:ratePlanId/rate-plan-interval(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {RatePlanInterval}
     * @protected
     */
    newModel(attributes, ...params) {
        
        return new RatePlanInterval(attributes);
    }
    
    /**
     * @param {Object=} params
     * @param {RatePlan=} ratePlan
     * @returns {Promise.<PaginationCollection<RatePlanInterval>>}
     */
    get(params = {}, ratePlan = null) {
        
        const url = this.url({
            propertyId: ratePlan ? ratePlan.property_id : 0,
            ratePlanId: ratePlan ? ratePlan.id : 0
        });
        
        const ignoreLB = params.hasOwnProperty('searchValue');
        
        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {RatePlanInterval} ratePlanInterval
     * @param {RatePlan} ratePlan
     * @returns {Promise.<RatePlanInterval>}
     */
    create(ratePlanInterval, ratePlan) {
        
        const url = this.url({
            propertyId: ratePlan.property_id,
            ratePlanId: ratePlan.id
        });
        
        return this.http
            .post(url, this.prepareModel(ratePlanInterval.toObject()), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {RatePlanInterval} ratePlanInterval
     * @param {RatePlan} ratePlan
     * @returns {Promise.<RatePlanInterval>}
     */
    update(ratePlanInterval, ratePlan) {
        
        const url = this.url({
            propertyId: ratePlan.property_id,
            ratePlanId: ratePlan.id,
            id: ratePlanInterval.id
        });
        
        return this.http
            .put(url, this.prepareModel(ratePlanInterval.toObject()), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {RatePlanInterval} ratePlanInterval
     * @returns {Promise.<boolean>}
     */
    delete(ratePlanInterval) {
        
        const url = this.url({
            propertyId: ratePlanInterval.rate_plan.property_id,
            ratePlanId: ratePlanInterval.rate_plan.id,
            id: ratePlanInterval.id
        });
        
        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Array} ids
     * @param {RatePlan} ratePlan
     * @returns {Promise.<boolean>}
     */
    bulkDelete(ids, ratePlan) {
        
        const url = this.url({
            propertyId: ratePlan.property_id,
            ratePlanId: ratePlan.id
        });
        
        return this.http
                   .post(url + '/bulk-delete', {'ids': ids}, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Object}
     * @returns {Object}
     */
    prepareModel(model) {
        
        model.start_date = moment(model.start_date).format('YYYY-MM-DD');
        model.end_date = moment(model.end_date).format('YYYY-MM-DD');
        
        //transform to sync pivot data
        let roomTypes = {};
        
        for (let type of model.property_accommodation_types) {
            
            roomTypes[type.id] = type.pivot;
        }
        
        model.property_accommodation_types = roomTypes;
        
        return model;
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/rate-plan-interval.service.js